import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

import { GrClose } from "react-icons/gr"

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: "0.5rem"
};

export default function CustomModal(props) {



    const { heading, desc } = props.allData


    return (
        <div>
            <Modal
                open={props.isOpen}
                onClose={() => props.handleCloseModal()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>

                    <div className="heading flex items-center justify-between">
                        <div className="left">

                            <h2 className='underline text-xl font-bold'>{heading}</h2>
                        </div>
                        <div className="right">
                            <GrClose className='cursor-pointer' onClick={props.handleCloseModal} />
                        </div>
                    </div>

                    <div className="content mt-3">
                        <h3 className='text-md font-semibold'>Details</h3>
                        <p className=' text-justify text-sm mt-1'>{desc}</p>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}
